import { H2, L, Note, P, Ul } from '@/features/guide/prose'

export function BranchOperationEn() {
  return (
    <>
      <P>
        Go to romi.io.vn/restaurant-url (replace “restaurant-url” with your real URL name) and log in, or log in and open the restaurant through{' '}
        <L k="nav.myRestaurants" />. Open a branch to reach the branch page. Staff press <L k="landing.openQueue" />; an <L k="role.admin" /> or above
        presses <L k="landing.manageBranch" /> and then picks <L k="nav.queue" /> from the menu.
      </P>
      <P>
        There are 4 operation pages: <L k="nav.queue" />, <L k="nav.sessions" />, <L k="nav.createOrder" /> (staff create orders for customers) and{' '}
        <L k="nav.search" /> (orders and sessions).
      </P>
      <H2>Queue</H2>
      <Ul>
        <li>
          By default it shows the 4 active statuses: <L k="track.status.sent" />, <L k="track.status.confirmed" />, <L k="track.status.processing" /> and{' '}
          <L k="track.status.ready" />. Tap a status at the top to hide or show it; the choice is remembered on that device (for example, the kitchen screen
          shows only the confirmed and preparing orders, while the floor staff’s screen shows the sent and ready ones). At least one status always stays
          visible.
        </li>
        <li>
          Each order has a button that moves it to the next status: <L k="queue.next.sent" />, <L k="queue.next.confirmed" />,{' '}
          <L k="queue.next.processing" />, <L k="queue.next.ready" />.
        </li>
        <li>The top of the page shows whether the shop is open and the current ordering PIN.</li>
      </Ul>
      <H2>Sessions</H2>
      <P>Every open session (a table with customers) is listed here. Open a table to see the session details.</P>
      <P>
        On the details page you can print the bill (<L k="orderDetails.print" />), move the session to another table (<L k="sessions.changeTable" />; if that
        table is busy, you can merge the two groups into one bill), and close the session (<L k="sessions.close" />) after the customers have paid so the table
        is ready for the next group. A session cannot be closed while it still has active orders; complete or cancel them first.
      </P>
      <Note>
        Always close the session after the customers pay. Otherwise the old orders stay in the session, and the next group at that table will see the old
        orders together with their own.
      </Note>
      <H2>Create order</H2>
      <P>
        Staff create orders for customers here. Choose <L k="createOrder.dineIn" /> with a table or <L k="order.takeAway" />, and optionally{' '}
        <L k="createOrder.forCustomer" /> so the order shows in the customer’s history. Orders created by staff start in the{' '}
        <L k="track.status.confirmed" /> status.
      </P>
      <H2>Search</H2>
      <P>Helps staff find a specific order or session, by its code, by order number and date, or by table.</P>
    </>
  )
}
